import http from '@/services/http';

/**
 * Note:
 * Endpoint requests all "pared" down table tickets (ie. orders) for the sole purpose of rendering all table orders in a simple list.
 * Similar to `/cardfree-api/v1/pat/pay/${query.merchantLocationId}/tickets`, with query param of t: tableNumber. This endpoint returns "non-pared"
 * down orders, which is a heavy and slow request.
 */
async function getTableTickets({ dispatch, rootState }) {
  const { tableNumber, merchantLocationId } = rootState.session.route;

  try {
    const requestPayload = { params: { tb: tableNumber } };

    const response = await http.get(`/cardfree-api/v1/pat/pay/${merchantLocationId}/tickets-by-sublocation`, requestPayload);

    if (response.data.length) {
      const [orderData] = response.data;

      const dispatchPayload = { response: { data: { orders: orderData.orders } } };

      await dispatch('setTableOrders', dispatchPayload);
    }
  }
  catch (error) {
    throw error;
  }
}

export { getTableTickets };
